import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Grid, MenuItem, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { useAssignContactTag, useUnassignContactTag } from '../../../sic-lib/api/hooks/useContact';
import { ContactTagWithFlag } from '../../../sic-lib/types/ContactTag';
import ButtonLoading from '../../Shared/ButtonLoading';

interface Props {
    contactId: number;
    data: ContactTagWithFlag;
    style: React.CSSProperties;
}

export default function TagListItem({ contactId, data, style }: Props) {
    const { classes } = useStyles();
    const { mutate: assignTagMutation, isLoading: isAssignLoading } =
        useAssignContactTag(contactId);

    const { mutate: unAssignTagMutation, isLoading: isUnAssignLoading } =
        useUnassignContactTag(contactId);

    const handleSelect = (value: ContactTagWithFlag) => {
        if (!value) return;
        if (value.tagId) {
            unAssignTagMutation(value.tagId);
        } else {
            assignTagMutation(value.tagId);
        }
    };
    return (
        <MenuItem
            style={style}
            key={data.tagId}
            onClick={() => handleSelect(data)}
            onKeyDown={e => e.stopPropagation()}
        >
            <Grid container direction="row" justifyContent="space-between" wrap="nowrap">
                <Typography variant="inherit" noWrap>
                    {data.tag}
                </Typography>
                <ButtonLoading
                    isLoading={isAssignLoading || isUnAssignLoading}
                    size="small"
                    startIcon={data.flag === 'assigned' ? <RemoveIcon /> : <AddIcon />}
                    style={{ fontSize: '0.60rem' }}
                >
                    {data.flag === 'assigned' ? 'Remove' : 'Add'}
                </ButtonLoading>
            </Grid>
        </MenuItem>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    menuBorder: {
        borderTop: `1px solid ${theme.palette.divider}`,
    },
}));
